import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Use lazy loading for the main App component
const App = lazy(() => import('./App'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<div className="loading">...</div>}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);

// Measure performance and send to analytics if needed
reportWebVitals(console.log);
